import React from 'react';
import firebase from '../config/firebaseConfig';

class FirebaseAuth extends React.Component {
    constructor(props) {
        super(props);
        this.unsubscribeAuth = null;
        this.state = {
            isSigningIn: false,
            error: null
        };
    }

    componentDidMount() {
        // Set persistence once on mount
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

        // Set up auth state listener once
        this.unsubscribeAuth = firebase.auth().onAuthStateChanged((userFromStorage) => {
            if (userFromStorage) {
                const user = {
                    uid: userFromStorage.uid,
                    displayName: userFromStorage.displayName,
                    email: userFromStorage.email,
                    photoURL: userFromStorage.photoURL
                };
                this.props.login(user);
            }
        });
    }

    componentWillUnmount() {
        // Clean up the listener to prevent memory leaks
        if (this.unsubscribeAuth) {
            this.unsubscribeAuth();
        }
    }

    handleGoogleSignIn = async () => {
        this.setState({ isSigningIn: true, error: null });

        const provider = new firebase.auth.GoogleAuthProvider();

        try {
            const result = await firebase.auth().signInWithPopup(provider);
            const user = {
                uid: result.user.uid,
                displayName: result.user.displayName,
                email: result.user.email,
                photoURL: result.user.photoURL
            };
            this.props.login(user);
        } catch (error) {
            console.error('Sign-in error:', error);
            this.setState({ error: error.message });
        } finally {
            this.setState({ isSigningIn: false });
        }
    };

    render() {
        const { isSigningIn, error } = this.state;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                <button
                    onClick={this.handleGoogleSignIn}
                    disabled={isSigningIn}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '10px 20px',
                        fontSize: '16px',
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        cursor: isSigningIn ? 'not-allowed' : 'pointer',
                        opacity: isSigningIn ? 0.7 : 1
                    }}
                >
                    <svg width="18" height="18" viewBox="0 0 48 48">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                    </svg>
                    {isSigningIn ? 'Signing in...' : 'Sign in with Google'}
                </button>
                {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
            </div>
        );
    }
}

export default FirebaseAuth;
